const DEFAULT_LOCALE = 'en-US';

export const getLocaleFromBrowser = () => {
  const isEnLocale = /en-?/.test(navigator.language || navigator.userLanuage);
  const isFrLocale = /fr-?/.test(navigator.language || navigator.userLanuage);
  return isEnLocale ? 'en-US' : isFrLocale ? 'fr-CA' : 'en-US';
};

export const languageLocaleMap = {
  'en-US': 'English',
  'fr-CA': 'French'
};

/**
 * Returns found or defualt locale in languageLocaleMap. Use for if you need to verify passed locale.
 *
 * @param {Array<Object>} locale - Locale string.
 * @returns {String} Verfiied, or default locale if provided locale was not found.
 */

export function getLocale(locale = DEFAULT_LOCALE) {
  return languageLocaleMap[locale] ? locale : DEFAULT_LOCALE;
}
